//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            opts: [
                 {
                text: '不限',
                value: ''
            },
            {
                text: '8000以下',
                value: '0-8000'
            },
            {
                text: '8000-12000',
                value: '8000-12000'
            },
            {
                text: '12000以上',
                value: '12000-9999999999'
            },
            ],
            selected: ''
        }
    },
    destroyed () {
        this.selected = ''
    },
    methods: {
        onSelect (e) {
            this.selected = e.currentTarget.dataset.value
        },
        reset () {
            this.selected = ''
        },
        confirm () {
            let selected_text = ''
            this.opts.some(({ text, value }) => {
                if (value === this.selected) {
                    selected_text = text
                    return true
                }
            })
            this.$emit('change', this.selected, selected_text)
        }
    }
}
